import imgSite from "url:./images/kuntotarkastus_nega.png";
import imgSite2x from "url:./images/kuntotarkastus_nega@2x.png";
import imgMap from "url:./images/map.png";
import imgMap2x from "url:./images/map@2x.png";

import imgMitenToimii1 from "url:./images/miten-toimii-1.png";
import imgMitenToimii2 from "url:./images/miten-toimii-2.png";
import imgMitenToimii3 from "url:./images/miten-toimii-3.png";

import imgSnapFingers from "url:./images/snap-fingers.png";
import imgSnapFingers2x from "url:./images/snap-fingers@2x.png";
import imgPlatform from "url:./images/platform.png";
import imgPlatform2x from "url:./images/platform@2x.png";

import imgHETSite from "url:./images/het-site.png";
import imgFacebookIcon from "url:./images/facebook-icon.png";

setImages("img_site", imgSite, "65w", imgSite2x, "130w", "50vw");
setImages("img_map", imgMap, "300w", imgMap2x, "600w", "50vw");
setImages("img_snapfingers", imgSnapFingers, "258w", imgSnapFingers2x, "516w", "50vw");
setImages("img_platform", imgPlatform, "258w", imgPlatform2x, "516w", "50vw");

setImage("img_mitentoimii1", imgMitenToimii1);
setImage("img_mitentoimii2", imgMitenToimii2);
setImage("img_mitentoimii3", imgMitenToimii3);


setImage("img_hetsite", imgHETSite);
setImage("img_facebookicon", imgFacebookIcon);

function setImage(elementId, imgSrc){
    let img  = document.getElementById(elementId); 
    if(img) img.src=imgSrc;
}

function setImages(elementId, imgSrc1, imgSrc1w, imgSrc2, imgSrc2w, sizes){
    let img  = document.getElementById(elementId); 
    if(img){
        img.srcset = imgSrc1 + ' ' + imgSrc1w + ', ' + imgSrc2 + ' ' + imgSrc2w;
        img.sizes = sizes;
    }
}